// Ported from design_ideas/lernwelt/bundle.jsx — full-screen chapter complete overlay

import { useEffect, useState } from 'react';
import { chapterBadgeUrl } from '../assets/illustrations';

interface Props {
  chapterTitle?: string;
  characterLine?: string;
  /** Arc id — if its badge has been baked, show it above the title. */
  arcId?: string;
}

export default function ChapterCompleteFlash({
  chapterTitle = 'Die Karte erwacht.',
  characterLine = 'Finn hat alle drei Rätsel gelöst.',
  arcId,
}: Props) {
  const [badgeOk, setBadgeOk] = useState(false);

  useEffect(() => {
    if (!arcId) return;
    let cancelled = false;
    const img = new Image();
    img.onload  = () => { if (!cancelled) setBadgeOk(true); };
    img.onerror = () => { if (!cancelled) setBadgeOk(false); };
    img.src = chapterBadgeUrl(arcId);
    return () => { cancelled = true; };
  }, [arcId]);

  return (
    <div style={{
      position: 'absolute', inset: 0,
      background: 'rgba(10,14,20,0.85)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      animation: 'flash-in 0.3s ease-out',
      zIndex: 20,
      backdropFilter: 'blur(4px)',
    }}>
      <div style={{
        textAlign: 'center',
        color: '#f7ecd0',
        animation: 'chapter-pop 0.6s cubic-bezier(0.34, 1.56, 0.64, 1)',
      }}>
        {arcId && badgeOk && (
          <img
            src={chapterBadgeUrl(arcId)}
            alt=""
            width={160}
            height={160}
            style={{
              width: 160, height: 160, objectFit: 'contain',
              marginBottom: 14,
              filter: 'drop-shadow(0 6px 18px rgba(0,0,0,0.35))',
            }}
          />
        )}
        <div style={{
          fontFamily: 'var(--mono)',
          fontSize: 12, letterSpacing: '0.3em',
          color: 'var(--amber)',
          textTransform: 'uppercase',
          marginBottom: 10,
        }}>Kapitel abgeschlossen</div>
        <div style={{
          fontFamily: 'var(--display)',
          fontSize: 56,
          fontWeight: 600,
          letterSpacing: '-0.02em',
          marginBottom: 6,
        }}>{chapterTitle}</div>
        <div style={{
          fontFamily: 'var(--serif)',
          fontSize: 17, fontStyle: 'italic',
          opacity: 0.8,
        }}>{characterLine}</div>
      </div>
    </div>
  );
}
